import { selectChain } from "components/Stacker/actions/AmuletStackerActions"
import PropTypes from "prop-types"
import {
  setLoadStatus,
  stackerReset,
} from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import queryString from "query-string"
import React, { useCallback } from "react"
import { useLocation } from "react-router"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import { NextArrow, PreviousArrow } from "../../Common/Arrows/Arrows"
import NecklaceChooserItem from "../NecklaceChooserItem/NecklaceChooserItem"
import "./NecklaceChooser.scss"
import shadowDOM from "components/Stacker/utils/shadowDOM"
import { useState } from "react"
import { useLayoutEffect } from "react"
import { shallowEqual, useSelector } from "react-redux"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useRef } from "react"
import { useI18nContext } from "i18n/i18n-react"
import iconHelp from "assets/icons/icon-help.svg"
import { InlineSVGIcon } from "components/Stacker/SvgIcon"

// function debounce(func, wait, immediate) {
//   var timeout
//   return function () {
//     var context = this,
//       args = arguments
//     var later = function () {
//       timeout = null
//       if (!immediate) func.apply(context, args)
//     }
//     var callNow = immediate && !timeout
//     clearTimeout(timeout)
//     timeout = setTimeout(later, wait)
//     if (callNow) func.apply(context, args)
//   }
// }

function Chooser({ onHelpClick, pageSize: desiredPageSize }) {
  const { LL } = useI18nContext()
  const swatch = useSelector((state) => state.swatch)
  const products = useSelector(
    (state) => state.search.data.products,
    shallowEqual
  )

  const pageSize = useSelector((state) => {
    return state.stacker?.pagination
      ? state.stacker.pagination.pageSize
      : desiredPageSize
  })

  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [selected, setSelected] = useState({
    chainBaseProduct: undefined,
    chainVariantCode: undefined,
    isVehicle: false,
    thickness: undefined,
  })
  const pdp = useSelector((state) => state.pdp)
  const [loadedImageArr, setLoadedImageArr] = useState([])
  const isAppLoaded = useSelector((state) => state.stacker.isAppLoaded)
  const isSelected = selected.chainBaseProduct && selected.chainVariantCode
  const chooserClasses = classNames("chooser-chain", "position-relative")
  const pendingImages = useRef([])

  const onImageLoadedDebounced = useCallback(() => {
    // debounce(() => {
    //   const nextImageArr = [...loadedImageArr, ...pendingImages.current]
    //   pendingImages.current = []
    //   setLoadedImageArr(nextImageArr)
    // }, 200)
    if (pendingImages.current.length > 0) {
      const newSize = loadedImageArr.length + pendingImages.current.length
      setLoadedImageArr((images) => [...images, ...pendingImages.current])
      pendingImages.current = []
      if (!isAppLoaded) {
        if (newSize >= products.length) {
          dispatch(setLoadStatus(true))
        }
      }
    }
  }, [dispatch, isAppLoaded, loadedImageArr, pageSize])

  const onImageLoading = useCallback((id) => {
    // if (loadedImageArr.includes(id)) {
    //   return
    // } // Staged and rendered
    // if (pendingImages.current.includes(id)) {
    //   return
    // } // Staged but not yet rendered
    // // pendingImages.current = [...pendingImages.current, id]
    // // onImageLoadedDebounced() // Notify debounced function more incoming
    // if (loadedImageArr.length + 1 >= products.length) {
    //   dispatch(setLoadStatus(true))
    // }
    setLoadedImageArr((images) => [...new Set([...images, id])])
  }, [])

  useEffect(() => {
    if (products.length > 0 && loadedImageArr.length >= products.length) {
      dispatch(setLoadStatus(true))
    }
    if (products.length === 0 && loadedImageArr.length > 0) {
      setLoadedImageArr([])
    }
  }, [dispatch, loadedImageArr.length, products.length])

  useLayoutEffect(() => {
    const m = shadowDOM.getElementById("mainContentArea")
    m.classList.remove("bg-white")
    m.classList.add("bg-gray")
  }, [])

  // useEffect(() => {
  //   const isLoaded = loadedImageArr.length >= pageSize
  //   if(!isAppLoaded && isLoaded) {
  //       dispatch(setLoadStatus(true))
  //   }
  //   //if (isAppLoaded !== isLoaded)
  //     //setTimeout(() => dispatch(setLoadStatus(isLoaded)), 500)
  //   // return () => {
  //   //   dispatch(setLoadStatus(false))
  //   //   dispatch(stackerReset())
  //   // }
  // }, [dispatch, isAppLoaded, loadedImageArr.length, pageSize])

  useEffect(() => {
    return () => {
      dispatch(setLoadStatus(false))
      dispatch(stackerReset())
    }
  }, [dispatch])

  const onNextStep = useCallback(() => {
    const queryObj = queryString.parse(location.search, { decode: true })
    const addedStack = Array.isArray(queryObj.products)
      ? queryObj.products
      : queryObj.products
      ? [queryObj.products]
      : []
    const products = []

    for (const product of addedStack) {
      if (pdp[product]) {
        const bale_diameter = pdp[product].data.products.bale_diameter
          ? parseFloat(pdp[product].data.products.bale_diameter)
          : 0
        if (bale_diameter >= selected.thickness) {
          products.push(product)
        } else {
          console.log(
            `Can't add ${product} has it has a bale_diameter of ${bale_diameter} and needs ${selected.thickness}`
          )
        }
      }
    }

    const queryParamsString = queryString.stringify(
      {
        // Due to the metal grouping change in the search results
        // selected.chainBaseProduct isn't always aligned with variant, so...
        chainBaseProduct: selected.chainVariantCode.substr(0, 9),
        chainVariantCode: selected.chainVariantCode,
        thickness: selected.thickness,
        products: products,
      },
      { encode: true }
    )
    dispatch(selectChain(selected))
    navigate(`${location.pathname}?${queryParamsString}`)
  }, [dispatch, location.pathname, location.search, navigate, selected])

  useEffect(() => {
    if (selected.chainBaseProduct) {
      onNextStep()
    }
  }, [onNextStep, selected.chainBaseProduct])

  const onItemClick = useCallback(
    (chainBaseProduct, isVehicle, thickness) => {
      setSelected({
        chainBaseProduct,
        chainVariantCode: swatch[chainBaseProduct].selectedVariantCode,
        isVehicle,
        thickness,
      })
    },
    [swatch]
  )

  const getProductItems = useCallback(() => {
    return products.map((product, i) => {
      const swatchIndex =
        swatch &&
        swatch[product.baseProduct] &&
        swatch[product.baseProduct].baseProductCode === product.baseProduct
          ? swatch[product.baseProduct].selectedVariantIndex
          : product.selectedVariant

      return (
        <NecklaceChooserItem
          key={product.code}
          index={i}
          baseProduct={product.baseProduct}
          selected={selected.chainBaseProduct === product.baseProduct}
          selectedVariant={product.selectedVariant}
          variants={product.variants}
          swatchIndex={swatchIndex}
          onClick={onItemClick}
          onImageLoad={onImageLoading}
        />
      )
    })
  }, [onImageLoading, onItemClick, products, selected.chainBaseProduct, swatch])

  const getProductCarousel = useCallback((productItems) => {
    const sliderSettings = {
      cssEase: "ease-in-out",
      dots: true,
      infinite: true,
      lazyLoad: false,
      nextArrow: <NextArrow />,
      prevArrow: <PreviousArrow />,
      speed: 700,
      slidesToShow: 3,
      slidesToScroll: 3,
    }

    return (
      <div className="carousel-chain">
        <Slider className="slider" {...sliderSettings}>
          {productItems}
        </Slider>
      </div>
    )
  }, [])

  const productItems = getProductItems()
  const productCarousel = getProductCarousel(productItems)

  return (
    <React.Fragment>
      <div className={chooserClasses}>
        <React.Fragment>
          <section className="d-relative container-chains">
            <React.Fragment>
              <h2 className="title-choose-chain linotype-didot-font text-center d-xxxl-block text-black">
                {LL.amulets.chooseChain()}
              </h2>
              <div className="product-items-carousel d-none d-xl-block">
                {productCarousel}
              </div>
              <div className="product-items-mobile d-flex flex-column d-xl-none">
                {productItems}
              </div>
            </React.Fragment>
          </section>
          <hr className="d-none d-xl-block" style={{ visibility: "hidden" }} />
          <footer>
            <button
              className="btn btn-blackrect btn-nextstep mx-xl-auto d-block"
              disabled={!isSelected}
              onClick={onNextStep}
              style={{ visibility: "hidden" }}
            >
              {LL.amulets.nextStep()}
            </button>
          </footer>
          <button
            className="btn btn-icon icon icon-help d-lg-none"
            onClick={onHelpClick}
          >
            <InlineSVGIcon
              style={{
                display: "inline-block",
                height: 11,
                width: 11,
                marginLeft: -5,
                top: -5,
                position: "relative",
              }}
              signal={true}
              alt={LL.amulets.help()}
              className={""}
              iconSvgText={iconHelp}
            />
          </button>
          <button
            className="btn btn-text text-help d-none d-xl-block"
            onClick={onHelpClick}
          >
            {LL.amulets.help()}
          </button>
        </React.Fragment>
      </div>
    </React.Fragment>
  )
}

Chooser.propTypes = {
  onHelpClick: PropTypes.func,
  pageSize: PropTypes.number,
}

export default Chooser
